import { ELEMENT_NAMES } from '../../constants';
import { useThemesStore } from '../../store';

type ElementNames = (typeof ELEMENT_NAMES)[number];
export const useGetThemeConfig = (componentName: ElementNames) => {
  const { elementsConfig = {} } = useThemesStore();

  return elementsConfig?.[componentName] || {};
};

export default useGetThemeConfig;
